var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCineW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3208 13.7599C32.3208 16.9407 29.7416 19.5199 26.5608 19.5199C23.38 19.5199 20.8008 16.9407 20.8008 13.7599C20.8008 10.5791 23.38 7.99995 26.5608 7.99995C29.7416 7.99995 32.3208 10.5791 32.3208 13.7599Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8008 13.7599C20.8008 16.9407 18.2216 19.5199 15.0408 19.5199C11.86 19.5199 9.28076 16.9407 9.28076 13.7599C9.28076 10.5791 11.86 7.99995 15.0408 7.99995C18.2216 7.99995 20.8008 10.5791 20.8008 13.7599Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92 40C8.85888 40 8 35.9885 8 31.04C8 26.0916 8.85888 22.0801 9.92 22.0801H29.12C30.1811 22.0801 31.04 22.9402 31.04 24.0001V27.2001L40 22.0801V40L31.04 34.88V38.08C31.04 39.1398 30.1811 40 29.12 40H9.92Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCineW);
export default __webpack_public_path__ + "static/media/cine-w.ec502c0eef4eee549dba3e1debac6d91.svg";
export { ForwardRef as ReactComponent };